import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { Layout } from "../Layout/Layout";
import styles from "./SidebarLayout.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SidebarLayout = function SidebarLayout(_ref) {
  var main = _ref.main,
    sidebar = _ref.sidebar,
    _ref$hideSidebarOnMob = _ref.hideSidebarOnMobile,
    hideSidebarOnMobile = _ref$hideSidebarOnMob === void 0 ? false : _ref$hideSidebarOnMob,
    layout = _ref.layout;
  var hasSidebar = !!sidebar;
  var layoutClassname = '';
  if (layout) {
    layoutClassname = styles[layout];
  }
  return /*#__PURE__*/_jsx("div", {
    className: classnames({
      [styles.hasSidebar]: hasSidebar
    }),
    "data-e2e-name": "sidebar_layout",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.wrapper, layoutClassname),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.main,
          "data-e2e-name": "sidebar_layout_main",
          children: /*#__PURE__*/_jsx(Layout, {
            layout: "sidebarBody",
            children: main
          })
        }), hasSidebar && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.sidebar, {
            [styles.notShowSidebarOnMobile]: hideSidebarOnMobile
          }),
          "data-e2e-name": "sidebar_layout_sidebar",
          children: sidebar
        })]
      })
    })
  });
};